// src/plugins/bootstrap.js
import { Modal, Dropdown } from "bootstrap";

export default {
	install(app) {
		app.config.globalProperties.$bootstrap = { Modal, Dropdown };
	},
};
